
import Vue from 'vue';
import { TeamMember } from '@run-diffusion/shared';
import TeamMembersPicker from '@/components/TeamMembersPicker.vue';

export default Vue.extend({
	name: 'AddRunnitBoardMember',
	methods: {
		onTeamMembersSelect(selectedMembers: TeamMember[]) {
			this.$emit('select', selectedMembers);
		},
	},
	components: {
		TeamMembersPicker,
	},
});
